<template>
  <div id="question_view">
    <quiz-header />
    <component
      v-if="quizStore.question.id"
      :is="questionTypes[quizStore.question.type]"
      :question="quizStore.question"
      :answer="[]"
      v-model="choices"
    />
    <!-- <pre>{{ { choices, currentQuestion } }}</pre> -->
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useQuizStore } from "@/stores/quiz";
import QuizHeader from "@/components/QuizHeader.vue";
import QuestionQCM from "@/components/QuestionQCM.vue";
import QuestionQCU from "@/components/QuestionQCU.vue";
import QuestionQRS from "@/components/QuestionQRS.vue";
import QuestionQPO from "@/components/QuestionQPO.vue";
import QuestionQPA from "@/components/QuestionQPA.vue";
const quizStore = useQuizStore();
const route = useRoute();
const router = useRouter();

const questionTypes = {
  QCM: QuestionQCM,
  QCU: QuestionQCU,
  QRS: QuestionQRS,
  QPO: QuestionQPO,
  QPA: QuestionQPA,
};

const props = defineProps({
  questionId: {
    type: Number,
    required: true,
  },
});

const choices = ref([]);

console.log("in Question Preview");
</script>
